import { useInjection } from 'inversify-react';
import { Button, Spinner } from 'react-bootstrap';
import { useCallback, useEffect, useRef, useState } from 'react';
import { API } from '../services/HTTP';

const TODOS_ENDPOINT = 'users/me/todos';

type Todo = {
    id: string;
    title: string;
    note: string;
    deleteInProgress: boolean
};

export function ApiPage() {
    const api: API = useInjection("API");

    const titleInput = useRef<HTMLInputElement>(null);
    const noteInput = useRef<HTMLInputElement>(null);
    const [todos, setTodos] = useState<Todo[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    let refresh = useCallback(async () => {
        setIsLoading(true);
        var response = await api.get(TODOS_ENDPOINT);
        setTodos(JSON.parse(response.data) as any);
        setIsLoading(false);
    }, [api]);

    useEffect(() => {
        refresh().catch(err => console.error(err));
    }, [refresh]);


    return <>
        <h1>API Example</h1>
        <ul className="list-group">
            <li className="list-group-item" style={{ display: 'flex', alignItems: 'center' }}>
                <form action="#" onSubmit={
                    async (e: any) => {
                        e.preventDefault();
                        await api.post(TODOS_ENDPOINT, JSON.stringify({
                            title: titleInput.current?.value,
                            note: noteInput.current?.value,
                        }));
                        await refresh();

                        titleInput.current!.value = "";
                        noteInput.current!.value = "";
                    }}>
                    <input disabled={isLoading} type="text" placeholder='Title' ref={titleInput} />
                    &nbsp;
                    <input disabled={isLoading} type="text" placeholder='Note' ref={noteInput} />
                    &nbsp;
                    <input disabled={isLoading} className="btn btn-primary" type="submit" value="Create" />
                </form>
                {isLoading && (<Spinner animation="border" />)}
            </li>
            {todos.map(todo => (
                <li key={todo.id} className="list-group-item" style={{ display: 'flex', alignItems: 'center' }}>

                    <span style={{ fontWeight: 700, paddingRight: "30px" }}>{todo.title}</span> <span style={{ flex: 1 }}>{todo.note}</span>
                    <Button
                        className="fa fa-times"
                        disabled={todo.deleteInProgress}
                        onClick={async () => {
                            setTodos(todos.map(t => t.id === todo.id ? { ...t, deleteInProgress: true } : t));
                            await api.delete(`${TODOS_ENDPOINT}/${todo.id}`).catch((err) => {
                                console.error(err);
                                setTodos(todos.map(t => t.id === todo.id ? { ...t, deleteInProgress: false } : t));
                            });
                            setTodos(todos.filter(one => one.id !== todo.id));
                        }}
                    >{todo.deleteInProgress ? <Spinner animation="border" /> : "X"}</Button>
                </li>
            ))}
        </ul>
    </>
}